import React,{ Component } from 'react';
import { Message } from 'semantic-ui-react';
import html2canvas from 'html2canvas';
import DraggablePanel from '../components/DraggablePanel';
import '../style/Position.css';
import AWS from 'aws-sdk';
import Promise from 'promise';
import ReactGA from 'react-ga';
import PropTypes from 'prop-types'
import {  Dimmer,Loader } from 'semantic-ui-react';
import MapboxGl from 'mapbox-gl/dist/mapbox-gl.js'
import '../style/Map.css';
import * as MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import uuid from 'uuid';
import NumericInput from 'react-numeric-input';
import PanelDetail from '../components/PanelDetail';
import '../style/Planner.css';


const s3 = new AWS.S3({
  region:'us-west-2',
  Bucket:'legionsolar-web-app'
});

class Planner extends Component{

  constructor(props){
    super(props);
    this.state = {
      warning : false,
      nullNumber : 0,
      uploading : false,
      x:"-20.012006",
      y:"20.077361",
      map:null,
      uuid:null,
      watts: 300,
      ACPower : '120VAC',
      selectedPanel: 0,
      selectedPanelProps: {
        rotation:0,
        inclination: 0,
        mountType: null
      }
    }
    this.isValidated = this.isValidated.bind(this);
  }

  static childContextTypes = {
    map: PropTypes.object
  }

  getChildContext = () => ({
    map: this.state.map
  })


  isValidated(){
    var np = localStorage.getItem('watts');
    np = np /300;
    for( var i = 0 ; i < np; i++){
      if(localStorage.getItem('mountType' + i) == null ){
        this.setState({
          nullNumber : i + 1,
          warning : true
        })
        return false;
      }
    }
    this.setState({
      uploading: true,
    });

    return new Promise((resolve, reject) => {
      this.captureMap();
      setTimeout(() => {
        // call resolve() to indicate that server validation or other aync method was a success.
        // ... only then will it move to the next step. reject() will indicate a fail
        resolve();
        // reject(); // or reject
      }, 1000);
    });
  }
  fireTracking() {
    ReactGA.pageview('planner');
  }

  captureMap(){
    return (html2canvas(document.querySelector(".capture")).then(canvas => {
      this.saveDataToS3(canvas.toDataURL());
    }));
  }

  saveDataToS3(file){
    const s3 = new AWS.S3({
      region:'us-west-2',
      Bucket:'legionsolar-web-app'
    });

    var params = {
      Bucket:'legionsolar-web-app',
      Key: 'PanelsMap/' + localStorage.getItem('uuid'),
      Body:file,
    };

    s3.upload(params, (err,data) =>{
      if(err){
        //   console.log('error !!! '+ JSON.stringify(err,null,2));
      }else{
        //   console.log('success!!!' + JSON.stringify(data,null,2))
      }
    })
  }

  draw(){
    const canvas = document.getElementById('mapImg');
    const ctx = canvas.getContext('2d');
    var img = new Image();
    img.onload = () =>{
      ctx.canvas.width = img.width;
      ctx.canvas.height = img.height;
      ctx.drawImage(img, 0, 0, img.width, img.height);
    }
    var params = {
      Bucket: "legionsolar-web-app",
      Key: 'OriginalMap/' + localStorage.getItem('uuid'),
    };
    s3.getObject(params, function(err, data) {
      //  if (err)
      //     // console.log(err, err.stack); // an error occurred
      //  else{
      //     // console.log("data"+data);           // successful response
      //  }
      if(data === null){
        return;
      }
      img.src = data.Body;
    });
  }
  componentDidMount(){
    ReactGA.initialize('UA-120152287-1'); //Unique Google Analytics tracking number
    this.generateUuid();
    MapboxGl.accessToken = "pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4M29iazA2Z2gycXA4N2pmbDZmangifQ.-g_vE53SD2WrJ6tFX7QHmA"
    const map = new MapboxGl.Map({
      container: this.container,
      style: 'mapbox://styles/mapbox/satellite-v9',
      preserveDrawingBuffer: true
    })
    var geocoder = new MapboxGeocoder({
      accessToken: MapboxGl.accessToken,
      zoom:20.1,
      placeholder: "Example: 2526 Qume Dr. San Jose 95131 CA"
    });

    map.flyTo({
      center: [this.state.x, this.state.y],
      zoom:0.5,
      speed:4
    })
    map.on('load', (...args) => {
      this.setState({ map })
    })
    //map.addControl(geocoder);

    document.getElementById('geocoder').appendChild(geocoder.onAdd(map));
    map.scrollZoom.disable();
    this.fireTracking();

    //this.draw();
  }


  //generate UUID
  generateUuid(){
    if(localStorage.getItem('uuid') !== null){
      this.setState({
        uuid : localStorage.getItem('uuid')
      })
    }else{
      this.setState({
        uuid : uuid()
      },() =>{
        localStorage.setItem('uuid',this.state.uuid);
      });
    }
  }

  //number here is watts
  handleWattChange(number){
    var wattsNumber = parseInt(number,10);
    var realPrice;

    if(wattsNumber === 0){
      realPrice = 0;
    }else{
      this.setState({
        warning : false
      })
      realPrice = (wattsNumber/300 - 1) * 449 + 599
    }
    this.setState({
      watts : number,
      price : realPrice
    })

  }

  onSelectPanel = panelNumber => {
    this.setState({
      selectedPanel: panelNumber
    });
  };

  onRotationChange = rotation => {
    this.setState({
      selectedPanelProps: {
        ...this.state.SelectedPanelProps,
        rotation
      }
    });
  }

  onInclinationChange = inclination => {
    this.setState({
      selectedPanelProps: {
        ...this.state.SelectedPanelProps,
        inclination
      }
    });
  }

  onPrint = () => {
    window.print();
  }

  render(){
    const { children } = this.props;
    const { map } = this.state;
    return(
      <div className="row system step-position">
        {/*<div className="col-lg-12 col-md-12">
         <div className="_title">
         Build Your System - POSITION
         </div>
         </div>*/}
        <div className='col-lg-12 col-md-12'>
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className='Map' ref={(x) => { this.container = x }}>
                <Dimmer active={this.state.uploading}>
                  <Loader
                    indeterminate
                    size='big'
                  >Constructing</Loader>
                  { map && children }
                </Dimmer>
              </div>

            </div>
          </div>
          {this.state.warning === true &&
          <Message
            className='positionWarning'
            warning
            header= 'Error!'
            content={ 'Panel ' + this.state.nullNumber + ' mount type not selected yet.'}
          />
          }
        </div>
        <div className="col-lg-12 col-md-12">
          <div className="row">
            <div className="col-lg-4 col-md-4 col-sm-4 text-center">
              <div className="geocoder-wrapper">
                <div id="geocoder" className="geocoder text-center">
                  <label>Step 1. Enter Your Location</label>
                </div>
                <div><span style={{fontSize:'11px',marginTop:'6px'}}>Please wait for the map to finish zooming before proceding to Step2.</span></div>
              </div>
            </div>
            <div className="col-lg-8 col-md-8 col-sm-8 text-center">

              <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-6" style={{background: "#e5ebf0"}}>
                  <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 text-center">
                      <div className='system_size_Input' >
                        <div className='system_SizeInput'>
                          <label> Step 2. System Size</label>
                        </div>
                        <NumericInput
                          className='number_control'
                          strict={true}
                          value={this.state.watts}
                          min={0}
                          max={9600}
                          size={15}
                          step={300}
                          mobile={false}
                          format={num => num + ' watts'}
                          onChange={valueAsNumber => this.handleWattChange(valueAsNumber)}
                        />

                      </div>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12">
                      <DraggablePanel number={this.state.watts} onSelectPanel={this.onSelectPanel} panelNumber={this.state.selectedPanel}/>

                    </div>
                  </div>


              </div>
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                      { this.state.panelNumber !== null  &&
                      <PanelDetail
                        panelnumber={this.state.selectedPanel}
                        onRotationChange={this.onRotationChange}
                        onInclinationChange={this.onInclinationChange}
                      />
                      }
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12">
                      <button onClick={this.onPrint} className="nextButton d-print-none">PRINT</button>

                    </div>
                  </div>

                </div>


            </div></div>

          </div>

        </div>

      </div>
    );
  }
}

export default Planner;



// WEBPACK FOOTER //
// ./src/components/Planner.js